import { Component, EventEmitter, Input, Output } from '@angular/core';

export type DatePreset =
  | 'TODAY'
  | 'YESTERDAY'
  | 'LAST_7_DAYS'
  | 'LAST_WEEK'
  | 'LAST_30_DAYS'
  | 'LAST_MONTH'
  | 'LAST_12_MONTHS'
  | 'CUSTOM';

@Component({
  selector: 'app-date-preset-selector',
  templateUrl: './date-preset-selector.component.html',
  styleUrls: ['./date-preset-selector.component.scss'],
})
export class DatePresetSelectorComponent {
  @Input() selectedPreset: DatePreset = 'LAST_7_DAYS';
  @Output() presetChange = new EventEmitter<DatePreset>();

  presets: Array<{ value: DatePreset; labelKey: string }> = [
    { value: 'TODAY', labelKey: 'admin.store.statistics.datePreset.today' },
    {
      value: 'YESTERDAY',
      labelKey: 'admin.store.statistics.datePreset.yesterday',
    },
    {
      value: 'LAST_7_DAYS',
      labelKey: 'admin.store.statistics.datePreset.last7Days',
    },
    {
      value: 'LAST_WEEK',
      labelKey: 'admin.store.statistics.datePreset.lastWeek',
    },
    {
      value: 'LAST_30_DAYS',
      labelKey: 'admin.store.statistics.datePreset.last30Days',
    },
    {
      value: 'LAST_MONTH',
      labelKey: 'admin.store.statistics.datePreset.lastMonth',
    },
    {
      value: 'LAST_12_MONTHS',
      labelKey: 'admin.store.statistics.datePreset.last12Months',
    },
    { value: 'CUSTOM', labelKey: 'admin.store.statistics.datePreset.custom' },
  ];

  onPresetClick(preset: DatePreset): void {
    this.selectedPreset = preset;
    this.presetChange.emit(preset);
  }

  isSelected(preset: DatePreset): boolean {
    return this.selectedPreset === preset;
  }
}
